module.exports = __webpack_public_path__ + "static/img/teens_cyberbullying.1f080e3a.png";